import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import ScrollToTop from './components/scrollToTop';

function AppRoutes() {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home page={'home'} />} />
                <Route path="/company" element={<Home page={'company'} />} />
                <Route path="/collections/:productId" element={<Home page={'watches'} />} />
                <Route path="/collections/:collectionId/:variantId" element={<Home page={'variant'} />} />
                <Route path="/clockwork/clockworktourmaline" element={<Home page={'clockworktourmaline'} />} />
                <Route path="/clockwork/clockworklight" element={<Home page={'clockworklight'} />} />
                <Route path="/clockwork/atomic" element={<Home page={'atomic'} />} />
                <Route path="/elements/diamondglass" element={<Home page={'diamondglass'} />} />
                <Route path="/collections/tourmaline" element={<Home page={'tourmaline'} />} />
                <Route path="/collections/snake" element={<Home page={'snake'} />} />
                <Route path="/collections/fluoring" element={<Home page={'fluoring'} />} />
                <Route path="/collections/chinese_zodiacs" element={<Home page={'chinese_zodiacs'} />} />
                <Route path="/jewellery/collections/:collectionId/:itemId" element={<Home page={'jewellery_item'} />} />
                <Route path="/tourmalines" element={<Home page={'tourmalines'} />} />
                <Route path="/tourmalines/tourmalines" element={<Home page={'tourmalines'} />} />
                <Route path="/philosophy" element={<Home page={'philosophy'} />} />
                <Route path="/philosophy/vision" element={<Home page={'philosophy'} />} />
                <Route path="/philosophy/books" element={<Home page={'books'} />} />
                <Route path="/stores/stores" element={<Home page={'stores'} />} />
                <Route path="/cypherglass" element={<Home page={'cypherglass'} />} />
                <Route path="/company/ourstory" element={<Home page={'company'} />} />
                <Route path="/maison/our_innovations" element={<Home page={'our_innovations'} />} />
                <Route path="/maison/patents" element={<Home page={'patents'} />} />
                <Route path="/commitments/social" element={<Home page={'social_commitment'} />} />
                <Route path="/commitments/environment" element={<Home page={'environmental_commitment'} />} />
                <Route path="/commitments/culture" element={<Home page={'culture'} />} />
                <Route path="/elements/tourmalinefrequency" element={<Home page={'tourmalinefrequency'} />} />
                <Route path="/important_objects/the_biggest_gemstone" element={<Home page={'the_biggest_gemstone'} />} />
                <Route path="/important_objects/skridblatnir" element={<Home page={'skridblatnir'} />} />
                <Route path="/important_objects/money_art" element={<Home page={'money_art'} />} />
                <Route path="/important_objects/fidrildi_stone" element={<Home page={'fidrildi_stone'} />} />
                <Route path="/important_objects/infinite_insight" element={<Home page={'infinite_insight'} />} />
                <Route path="/imprint" element={<Home page={'imprint'} />} />
            </Routes>
        </>
    );
}

export default AppRoutes; 
